export const REACT_APP_G_MAP = process.env.REACT_APP_G_MAP;
export const REACT_APP_API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export const URL_MES_COURSE = 'https://myedusolve.com/mesx-courses';

export const API_MES = 'https://mes-new-api.myedusolve.com/api';
